/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>推荐用户资料</el-breadcrumb-item>
      <el-breadcrumb-item>推荐分类管理</el-breadcrumb-item>
    </el-breadcrumb>
	<div class="block">
		 <el-radio-group v-model="formProInfo.category" style="margin-bottom: 30px; margin-right: 30px;" @change="changetypelei">
			 <el-radio-button label="1" >产品推荐分类</el-radio-button>
			 <el-radio-button label="2">活动推荐分类</el-radio-button>
		 </el-radio-group>
	</div>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
			<!-- <el-form-item label="类别">
			 <el-select size="small" v-model="formProInfo.category" placeholder="请选择" @change="changetypelei">
			     <el-option label="产品推荐分类" value="1"></el-option>
				 <el-option label="活动推荐分类" value="2"></el-option>
			  </el-select>
			</el-form-item> -->
			
          <el-form-item label="名称" >
            <el-input size="small" v-model="formProInfo.name" placeholder="输入分类名称"></el-input>
          </el-form-item>
		  
		  <el-form-item label="状态">
		   <el-select size="small" v-model="formProInfo.active" placeholder="请选择">
		       <el-option label="启用" value="1"></el-option>
		       <el-option label="禁用" value="0"></el-option>
		    </el-select>
		  </el-form-item>
		  
    	  <el-form-item label="操作人">
    	    <el-input size="small" v-model="formProInfo.updator" placeholder="输入创建人"></el-input>
    	  </el-form-item>
		 
         <!-- <el-form-item label="创建时间">
    	    <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
    	  </el-form-item>
          <el-form-item> -->
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea" class="refrea">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search" class="search">搜索</el-button>
           
          </el-form-item>
        </el-form>
		 <el-button size="small" type="primary" icon="el-icon-plus" @click="add" class="add">新增</el-button>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
		  <el-table-column align="center" prop="sortNumber" label="排序" >
		  </el-table-column>
          <el-table-column align="center" sortable prop="name" label="名称" >
		  </el-table-column>
		  <el-table-column align="center" sortable prop="category" label="所属分类" >
		  </el-table-column>
		  <el-table-column align="center" sortable prop="active" label="状态" >
		  </el-table-column>
		  <el-table-column align="center" sortable prop="updator" label="最后操作人" >
		  </el-table-column>
		  <el-table-column align="center" sortable prop="updateTime" label="创建时间" >
		  </el-table-column>
         
          <el-table-column  align="center"  sortable label="操作" min-width="140">
            <template slot-scope="scope">

              <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
              <el-button size="mini"  type="primary" @click="handleEdit(scope.row)">编辑</el-button>
			  <!-- <el-button size="mini" type="danger" @click="deleteProInfo(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        
      </div>
    </template>

    <script>
    import {
      queryPageRecommendTypeList
	  
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
         
          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            // 产品名称(支持右模糊查询)
            name: '',
            //创建人(支持右模糊查询)
            updator: '',
            //所属导购：1-导购知识视频；2-服务视频；3-导购文件
            category:'',
            //分类状态：0-禁用；1-启用
            active:''
			
          },
    	  proInfoList:[],
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formProInfo)

      },
      mounted(){
		 // console.log(9090909,this.$route.query)
		  if(this.$route.query.category==1||this.$route.query.category==2){
			this.formProInfo.category = String(this.$route.query.category) 
		  }else{
			  this.formProInfo.category = 1
		  }
		
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  //添加
		  add: function() {
		  	this.$router.push({ path: '/categoriesadd?shuo=' + '新增' + '&category='+ this.formProInfo.category})
		   
		  },
		  //编辑
		  handleEdit: function(row) {
		  	console.log(99999,row)
		  	this.$router.push({ path: '/categoriesadd?id='+row.id + '&shuo=' + '编辑' + '&category='+ this.formProInfo.category })
		   
		  },
		  changetypelei(e){
			  this.getData(this.formProInfo)
		  },
		  changetype(e){
			  console.log(123456,e)
			  //this.formProInfo.firstLevelId = e
			  let parm = {
					 level:2,
					 category:3,
					 firstLevelId:this.formProInfo.firstLevelId,
					 secondLevelId:''
						 
			  }
			  getShoppyTypeList(parm).then(res => {
				console.log(123)
				this.loading = false
				if (res.success == false) {
				  this.$message({
					type: 'info',
					message: res.msg
				  })
				} else {
				this.formProInfo.secondLevelId = null
				this.formProInfo.thirdLevelId = null
				this.typeList2 = res.data
				
				}
			  })
		  },
		  
		refrea(){
			this.formProInfo.name=''
			this.formProInfo.updator=''
			this.formProInfo.active=''
			this.formProInfo.firstLevelId=''
			this.formProInfo.secondLevelId=''
			this.formProInfo.thirdLevelId=''
			this.formProInfo.downloadStatus=''
			this.formProInfo.shareStatus=''
		},
       // 选择复选框事件
       selectChange(val) {
         this.selectdata = val
       },

        // 获取数据方法
        getData(pageparm) {
          this.loading = true
          queryPageRecommendTypeList(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
				  if(item.category==1){
					  item.category = '产品推荐分类'
				  }else{
					  item.category = '活动推荐分类'
				  }
				  if(item.active==1){
				  		item.active = '启动'
				  }else{
				  		item.active = '禁用'
				  }
			  })

              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


      }
    }
    </script>

    <style scoped>
    .user-search {
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 200px;
  }
  .el-input{
  	  width: 140px;
  }
  /deep/ .el-input--small{
  	  width: 140px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 60px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  .search{
	  position: absolute;
	  right: 0;
	  top: 68px;
  }
  .add{
	  margin-bottom: 30px;
  }
  .el-button--small{
	margin-top: 5px;  
  }
  .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  }
  .user-search{
	  position: relative;
  }
  /deep/ .el-radio-button__inner{
  	  width: 130px;
  }
  /deep/ .el-radio-button__inner{
  	  padding: 8px 20px;
  }
  .block{
  	  display: flex;
  	  margin-top: 30px;
  }
  /deep/ .block .el-input__inner{
  	  line-height: 32px;
  	  height: 32px;
  	  border: 0;
  }
  /deep/ .el-input__icon{
  	  font-size: 20px;
  	  height: 36px;
  	  line-height: 32px;
  }
    </style>





// WEBPACK FOOTER //
// src/views/userprofile/categories.vue